import { ArrowBigRight, Car, Forklift, GitFork } from "lucide-react";
import Button from "@/common/components/Button";
import { Link } from "react-router-dom";

export class ScrapRulesTransformer {
  static tableTransformer() {
    return (scrapRules: any[]) => {
      return scrapRules.map((scrapRule) => {
        return {
          ...scrapRule,
          action: (
            <Link to={scrapRule.id}>
              <Button name="access_scrap_rule" variant='link-white' className="w-full" operationKlassToCheckPermission="Admin::Maintenance::ScrapRules::Show">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        };
      });
    };
  }

  static formDataTransformer(scrapRule?: any) {
    if (!scrapRule) return {};

    return {
      display_name: scrapRule?.display_name,

      equipment_category_ids: scrapRule?.scrap_rule_equipment_categories?.map((item: any) => ({
        value: item.equipment_category.id,
        label: item.equipment_category?.display_name,
        icon: <Forklift strokeWidth={1} size={20} />
      })),

      branch_ids: scrapRule?.scrap_rule_branches?.map((item: any) => ({
        value: item.branch.id,
        label: item.branch.display_name,
        icon: <GitFork strokeWidth={1} size={20} />
      })),

      manufacturer_ids: scrapRule?.scrap_rule_manufacturers?.map((item: any) => ({
        value: item.manufacturer.id,
        label: item.manufacturer.display_name,
        icon: <Car strokeWidth={1} size={20} />
      })),

      equipment_model_ids: scrapRule?.scrap_rule_equipment_models?.map((item: any) => ({
        value: item.equipment_model.id,
        label: item.equipment_model.display_name,
        icon: <Car strokeWidth={1} size={20} />
      })),

      equipment_ids: scrapRule?.scrap_rule_equipments?.map((item: any) => ({
        value: item.equipment.id,
        label: item.equipment.field_for_display_value,
        icon: <Car strokeWidth={1} size={20} />
      })),

      has_mileage: !!scrapRule?.maximum_mileage_condition,
      maximum_mileage_condition: scrapRule?.maximum_mileage_condition?.toString(),

      has_hours: !!scrapRule?.maximum_usage_hours_condition,
      maximum_usage_hours_condition: scrapRule?.maximum_usage_hours_condition?.toString(),

      has_years: !!scrapRule?.maximum_usage_time_in_years_codition,
      maximum_usage_time_in_years_condition: scrapRule?.maximum_usage_time_in_years_codition?.toString()
    };
  }
}
